import { Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Mode } from '@ionic/core';

@Injectable({
  providedIn: 'root'
})
export class PopoverDropdownService {

  private popover: HTMLIonPopoverElement = null

  constructor(
    private popoverC: PopoverController
  ) { }

  public async dropdownAutocompleteDismiss(initial: string) {
    if (this.popover !== null) {
      await this.popover.dismiss({ item: initial })
    }
    const popover = await this.popoverC.getTop();
    if (popover) {
      popover.dismiss({ item: initial });
    }
  }

  public existDropdown = async () => await this.popoverC.getTop() ? true : false;

  /**
   * Este servicio presenta un popover en la vista
   * @param component El componente que se mostrará dentro del popover.
   * @param componentProps Los datos que se van a pasar al componente popover.
   * @param event El evento que se pasará a la animación emergente.
   * @param cssClass Clases adicionales para solicitar CSS personalizado. Si se proporcionan varias clases, deben estar separadas por espacios.
   * @param mode El modo determina qué estilos de plataforma usar.
   * @param animated Si true, el popover se animará.
   * @param backdropDismiss Si true, la ventana emergente se descartará cuando se haga clic en el fondo.
   * @param showBackdrop Si true, se mostrará un fondo detrás de la ventana emergente.
   * @param translucent Si true, el popover será translúcido. Solo se aplica cuando el modo es "ios"y el dispositivo lo admite backdrop-filter.
   * @param keyboardClose Si true, el teclado se cerrará automáticamente cuando se presente la superposición.
   */
  public presentPopover = async (
    component: any
    , componentProps: any
    , event: Event
    , cssClass: string
    , mode: Mode
    , animated: boolean
    , backdropDismiss: boolean
    , showBackdrop: boolean
    , translucent: boolean
    , keyboardClose: boolean
  ) => {
    this.popover = await this.popoverC.create({
      component
      , componentProps
      , showBackdrop
      , backdropDismiss
      , translucent
      , cssClass: cssClass || 'mpe-popover-ios'
      , event
      , animated
      , mode
      , keyboardClose: keyboardClose || false
      // , size: 'auto'
      , dismissOnSelect: true
      // , reference: 'trigger'
      // , side: 'bottom'
      // , align: 'center'
      // , triggerAction: 'hover'
    });

    await this.popover.present();

    const { data } = await this.popover.onWillDismiss();

    return data;
  }

  public dismissPopover = async (initialState: any) => {
    if (this.popover) {
      this.popover.dismiss(initialState);
    }
    const popo = await this.popoverC.getTop()
    if (popo) {
      popo.dismiss(initialState);
    }
  }

  public existPopover = (): boolean => this.popover === null ? false : true;


}
